import * as projectInformationAction from './project-information-action'

export {
  projectInformationAction,
}



// WEBPACK FOOTER //
// ./src/actions/project-information/index.js